import { render, staticRenderFns } from "./messenger.vue?vue&type=template&id=14c41acc&scoped=true&"
import script from "./messenger.vue?vue&type=script&lang=js&"
export * from "./messenger.vue?vue&type=script&lang=js&"
import style0 from "./messenger.vue?vue&type=style&index=0&id=14c41acc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c41acc",
  null
  
)

export default component.exports